
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paid-advertising-services/order-now",
      function () {
        return require("private-next-pages/paid-advertising-services/order-now/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/paid-advertising-services/order-now"])
      });
    }
  